export const ageMethod = "age nearest";
export const gateway = "https://qat-gbiconsultants-shopper-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/gbiconsultants";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJnYmljb25zdWx0YW50cyIsIm5hbWUiOiJnYmljb25zdWx0YW50cyIsImlhdCI6MTc4MDU4NDYwOCwiZXhwIjoxOTM4MzcyNjA4fQ.3noL7gFZ7BzQ7ahjsr-IecjatJwrk6vNsuE9xOC8YGE";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-gbiconsultants-shopper.link-nonprod.wawanesalife.com": {
		a: {
			approve_company: "Link Platform",
			approve_user: "link_gbiconsultants",
			brands: [
				"qat-gbiconsultants-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "gbiconsultants",
			broker_formatted_name: "GBI Consultants",
			email: "Info@gbiconsultants.ca",
			environment: "qat",
			environment_id: "qat",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1.613.651.2224",
			privacyLink: "https://dbyrj622lou2k.cloudfront.net/PrivacyPolicy2026.pdf",
			website: "https://gbiconsultants.ca/",
			scope: "gbiconsultants#branding#qat-gbiconsultants-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-gbiconsultants-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			approve_company: "Link Platform",
			approve_user: "link_gbiconsultants",
			brands: [
				"qat-gbiconsultants-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "gbiconsultants",
			broker_formatted_name: "GBI Consultants",
			email: "Info@gbiconsultants.ca",
			environment: "qat",
			environment_id: "qat",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1.613.651.2224",
			privacyLink: "https://dbyrj622lou2k.cloudfront.net/PrivacyPolicy2026.pdf",
			website: "https://gbiconsultants.ca/",
			scope: "gbiconsultants#branding#qat-gbiconsultants-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-gbiconsultants-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 14:50:08 GMT+0000 (Coordinated Universal Time)
